import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from 'app/@core/backend/common/api/http.service';
import { PatientData, PatientFilter } from 'app/@core/interfaces/common/CalorieFriend/patients';
import { ProgramTemplateData, TemplatePlan } from 'app/@core/interfaces/common/CalorieFriend/plan';
import { ProgramPlans, ProgramTemplate } from 'app/@core/interfaces/common/CalorieFriend/program-template';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'ngx-assing-plan-client',
  templateUrl: './assing-plan-client.component.html',
  styleUrls: ['./assing-plan-client.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssingPlanClientComponent implements OnInit {

  @Input() isMealPlan: boolean;
  @Input() planId: number;
  @Input() isProgramTemplate: boolean;
  @Input() programTemplate: TemplatePlan<ProgramPlans>;

  constructor(private patientsService: PatientData,
    private cd: ChangeDetectorRef,
    private router: Router,
    private api: HttpService) { }

  private readonly unsubscribe$ = new Subject<void>();
  dataList: any[] = [];

  showList: boolean = false;
  private paging: PatientFilter = {
    isArchived: false,
    sortBy: 'createdDate',
    orderBy: 'desc',
    pageSize: 1000,
  };


  ngOnInit(): void {

  }


  onAssingPlanClicked() {
    this.showList = true;

    this.patientsService
      .list(this.paging)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        this.dataList = res.items;
        this.cd.detectChanges();
      });



  }

  onSelectItem(id) {
    if(this.isProgramTemplate) {
      this.programTemplate.programPlans.mealPlan = this.programTemplate.programPlans.mealPlan?.map(x => {
        return {...x, patientID: id}
      });
      this.programTemplate.programPlans.fitnessPlans = this.programTemplate.programPlans.fitnessPlans?.map(x => {
        return {...x, patientID: id}
      });
      this.api.post('program-template/template/assign-patient', this.programTemplate).subscribe(res => {
        if(res) {
          this.router.navigate([
            '/pages/CalorieFriend/PatientSheetView/' + id.toString(), 
          ]);
        }
      })
      return
    }
    let route = !this.isMealPlan ? '/pages/CalorieFriend/NewFitnessPlan/' : '/pages/CalorieFriend/NewPlan/'

    this.router.navigate([
      route + id.toString(), 
    ],  { queryParams: { planId: this.planId.toString() } });

  }

}
